import APIHelper from "@giscon/utils.api-helper-esri";
import layerStore from "@giscon/utils.layer-store";

export function calculateRulePolygons(layers, map, highlighGraphicSymbol) {
  const layersWithEditRule = layers
    .map((layer, i) => {
      return { layer, i };
    })
    .filter(
      ({ layer }) =>
        layer.layerInfo &&
        layer.layerInfo.editRule &&
        layer.layerInfo.editRule.parts
    );
  /* layersWithEditRule.forEach(({ i }) => {
    layerStore.setPermissionsLoading(i);
  }); */
  const toProject = [];
  const geometryCounts = [];

  layersWithEditRule.map(({ layer, i }) => {
    let count = 0;
    const { editRule } = layer.layerInfo;
    const partsRings = editRule.parts.map((part) => part.rings);
    // create Polygons from rings
    partsRings.map((rings) => {
      const geometry = {
        rings: rings.map((ring) =>
          ring.points.map((point) => [point.x, point.y])
        ),
        spatialReference: editRule.coordinateSystem
          ? { wkid: 1 * editRule.coordinateSystem }
          : { wkid: 102362, latestWkid: 4647 },
      };

      toProject.push(APIHelper.createPolygon(geometry));
      count++;
    });
    const extent = APIHelper.getLayersFullExtent(layers[i], 2);

    // create Highlighgeometry
    if (extent) {
      const fullExtentPolygon = APIHelper.createPolygonFromExtent(extent);
      toProject.push(fullExtentPolygon);
      count++;
    } else {
      // eslint-disable-next-line no-console
      console.error(
        `Could not load fullExtent Polygon from Layer ${layers[i].url}`
      );
    }
    geometryCounts.push(count);
  });
  return new Promise((resolve, reject) => {
    APIHelper.projectGeometries(
      {
        geometries: toProject,
      },
      map
    )
      .then((projectedGeometries) => {
        geometryCounts.map((count, i) => {
          updateEditRule(
            // save geometries in Editrule
            layersWithEditRule[i].layer,
            projectedGeometries.splice(0, count),
            map,
            highlighGraphicSymbol
          );
          // layerStore.setPermissionsLoading(layersWithEditRule[i].i, false); // calculations for layer finished
        });
        resolve();
      })
      .catch((e) => {
        console.error("Projecting edit rules failed ", e);
        reject(e);
      });
  });
}

export function updateEditRule(layer, geometries, map, highlighGraphicSymbol) {
  let highlightGeometry = geometries.pop();
  const ruleGeometries = [];
  let zoomExtent = null;

  geometries.map((geometry) => {
    // const gra = getGraphicFromGeometry(geometry);
    if (!zoomExtent) {
      zoomExtent = APIHelper.getGeometriesExtent(geometry);
    } else {
      zoomExtent = APIHelper.getGeometriesExtent(geometry).union(zoomExtent);
    }
    highlightGeometry = APIHelper.differenceOfGeometries(
      highlightGeometry,
      geometry
    );
    ruleGeometries.push(geometry);
  });

  const highlightGraphic = APIHelper.createGraphic(
    APIHelper.createPolygon(highlightGeometry), // feature.geometry,
    highlighGraphicSymbol
  );

  // eslint-disable-next-line no-param-reassign
  layer.layerInfo.editRule.ruleGeometries = ruleGeometries;
  // eslint-disable-next-line no-param-reassign
  layer.layerInfo.editRule.ruleGeometry =
    APIHelper.unionOfGeomnetries(ruleGeometries);
  // eslint-disable-next-line no-param-reassign
  layer.layerInfo.editRule.highlightGraphic = highlightGraphic;
  // eslint-disable-next-line no-param-reassign
  layer.layerInfo.editRule.zoomExtent = zoomExtent;
}

export function createFeatureLayer(layerInfo, token) {
  try {
    const featureLayer = APIHelper.createFeatureLayer(layerInfo, {
      token,
    });
    /* // reflect Editing Infos onLayer
    featureLayer.editingInfo = {
      ...featureLayer.editingInfo,
      delete: layerInfo.delete,
      editRule: layerInfo.editRule,
      // hidden: layerInfo.hidden,
      insert: layerInfo.insert,
      // read: layerInfo.read,
      update_attribute: layerInfo.update_attribute,
      update_geometry: layerInfo.update_geometry,
    };
    */
    featureLayer.layerInfo = layerInfo;
    return featureLayer;
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error("Could not load layer ", error);
    throw new Error("Layer Could not be loaded");
  }
}

export function addAndLoadFeatureLayer(map, layer, wait) {
  const waitForLoaded =
    wait !== undefined
      ? wait
      : layer.layerInfo.update_geometry || layer.layerInfo.update_attribute; // TODO : checken !!! und ggf noch an Funktion übergebbar
  return APIHelper.addAndLoadLayer(layer, map, waitForLoaded);
} /* DO NOT MAKE NEWLINE => ESLINT WILL REMOVE PARTS OF THE COMMENT ...
  export function createAndLoadLayer(map, layerInfo, token, wait) {
    return LayerUtils.createFeatureLayer(layerInfo, token).then((layer) => {
      return LayerUtils.addAndLoadFeatureLayer(map, layer, wait);
    });
  }
  addFeatureLayers = (featureLayers) => {
  return new Promise((resolve, reject) => {
    const { map, setAddedLayers, context } = this.props;

    Promise.all(
      featureLayers.map(({ layer, info }) => {
        // must load immediately?
        const waitForLoaded =
          /* info.insert || info.delete || */ /* info.update_geometry ||
          info.update_attribute;
        return context.APIInterface.addLayer(layer, map, !waitForLoaded);
      }),
    )
      .then(() => {
        setAddedLayers(featureLayers);
        resolve(featureLayers);
      })
      .catch((layers) => {
        for (let i = 0; i < layers.length; i++) {
          if (layers[i]) context.APIInterface.removeLayer(layers[i], map);
        }
        reject();
      });
  });
};
*/
